module.exports = __webpack_public_path__ + "static/media/DiscoverRelevantVendors.aa7f2597.png";